(() => {
  const main=document.getElementById('MainContent');
  if(!main||main.dataset.aafSlides||matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;
  main.dataset.aafSlides='true';
  const sections=[...main.children].filter(node=>node.classList.contains('shopify-section'));
  const observer=new IntersectionObserver(entries=>{
    for(const entry of entries){
      if(!entry.isIntersecting)continue;
      entry.target.classList.add('aaf-slide-visible');observer.unobserve(entry.target);
    }
  },{threshold:.05});
  // The page itself animates on arrival; later sections alternate directions.
  sections.slice(1).forEach((section,index)=>{
    if(section.getBoundingClientRect().top<innerHeight)return;
    section.style.setProperty('--aaf-slide-x',index%2?'32px':'-32px');observer.observe(section);
  });
})();
